import apiClient from './Api';

const PREFIX = '/auth';

const login = postData => {
  return apiClient({
    url: `${PREFIX}/login`,
    method: 'POST',
    data: postData
  });
};

const directLoginById = postData => {
  return apiClient({
    url: `${PREFIX}/directlogin`,
    method: 'POST',
    data: postData
  });
};

const forgot = postData => {
  return apiClient({
    url: `${PREFIX}/forgot`,
    method: 'POST',
    data: postData
  });
};

const checkToken = postData => {
  return apiClient({
    url: `${PREFIX}/passtoken`,
    method: 'POST',
    data: postData
  });
};

const reset = postData => {
  return apiClient({
    url: `${PREFIX}/reset`,
    method: 'POST',
    data: postData
  });
};

const changePassword = postData => {
  return apiClient({
    url: `${PREFIX}/changepassword`,
    method: 'POST',
    data: postData
  });
};

// 2FA login
const signin = postData => {
  return apiClient({
    url: `${PREFIX}/signin`,
    method: 'POST',
    data: postData
  });
};

const resendotp = postData => {
  return apiClient({
    url: `${PREFIX}/resendotp`,
    method: 'POST',
    data: postData
  });
};

const verifyotp = postData => {
  return apiClient({
    url: `${PREFIX}/verifyotp`,
    method: 'POST',
    data: postData
  });
};

const reset2FA = postData => {
  return apiClient({
    url: `${PREFIX}/resetotp`,
    method: 'POST',
    data: postData
  });
};

const accountReset = postData => {
  return apiClient({
    url: `${PREFIX}/accountreset`,
    method: 'POST',
    data: postData
  });
};
const vapidPublicKey = () => {
  return apiClient({
    url: `/vapidPublicKey`,
    method: 'GET'
  });
};

const AuthService = {
  signin,
  resendotp,
  verifyotp,
  reset2FA,
  accountReset,
  login,
  forgot,
  checkToken,
  reset,
  changePassword,
  directLoginById,
  vapidPublicKey
};

export default AuthService;
